// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"cb73faef","522":"668a8fcf","545":"fa8d2789","551":"703e96ec","605":"3e0df2b9","662":"e94bb7df"}[chunkId] + ".chunk.js";
};